import { render } from "./PostpartumInitialTestResults.vue?vue&type=template&id=7312d88a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__